export default "__VITE_ASSET__CB5Cf6B$__"